import React from "react";
import { ModalControl } from "./ModalRoot";
import "./ModalLeftPanel.scss";

export default class ModalLeftPanel extends React.Component {
  render() {
    return (
      <div styleName="base">
        <ModalControl>
          {(modal) => (
            <div
              styleName="panel"
              onClick={() => {
                if (this.props.onClose) {
                  this.props.onClose();
                }
                modal.closeModal();
              }}></div>
          )}
        </ModalControl>
        <div
          styleName="window"
          style={{
            width: this.props.width,
            overflow: this.props.overflow,
          }}
          // style={this.props.width ? { width: this.props.width } : {}, this.props.overflow ? {overflow : this.props.overflow} : {}}
        >
          {/* <div styleName="header">
            {this.props.header}
            <ModalControl>
              {modal => (
                <div
                  styleName="cross"
                  onClick={() => {
                    if (this.props.onClose) {
                      this.props.onClose();
                    }
                    modal.closeModal();
                  }}
                ></div>
              )}
            </ModalControl>
          </div> */}
          <div>{this.props.children}</div>
        </div>
      </div>
    );
  }
}
